import efbridge from '@/lib/efbridge';
import type { LogEventProps, PushPageProps, PageConfigPorps, RegisterSuccessProps, RightConfigProps } from '@/types/bridge';

//获取app信息
export const appGetAppMsg = () => {
    return new Promise((resolve) => {
        efbridge?.registerHandler('getAppMsg', (res: any) => {
            console.log('bridge->appGetAppMsg->', res);
            if (res) {
                resolve(res);
            }
        });
    });
};

// 调用app埋点 数据传到firebase
export const appLogEvent = (params: LogEventProps) => {
    //console.log('logEvent->', params);
    return new Promise((resolve) => {
        efbridge?.callHandler(
            'logEvent',
            {
                ...params,
                data: params?.data || {},
            },
            (res: any) => {
                console.log('logEvent->result', res);
                if (res) {
                    resolve(res);
                }
            },
        );
    });
};

// 调用app跳转页面
export const appPushPage = (params: PushPageProps) => {
    return new Promise((resolve) => {
        efbridge?.callHandler(
            'pushPage',
            {
                ...params,
            },
            (res: any) => {
                if (res) {
                    resolve(res);
                    console.log('pushPage->', res);
                }
            },
        );
    });
};

//转入前台事件事件
export const appSetAppear = () => {
    return new Promise((resolve) => {
        efbridge?.registerHandler('appAppear', (res: any) => {
            console.log('appAppear->', res);
            if (res) {
                console.log('disappear->resolve', res);
                resolve(res);
            }
        });
    });
};

// 监听页面转入后台事件
export const appSetDisAppear = () => {
    return new Promise((resolve) => {
        efbridge?.registerHandler('disappear', (res: any) => {
            console.log('disappear', res);
            if (res) {
                console.log('disappear->resolve', res);
                resolve(res);
            }
        });
    });
};

//关闭当前webview
export const appCloseWebView = () => {
    return new Promise((resolve) => {
        efbridge?.callHandler('closeWebView', {}, (res: any) => {
            if (res) {
                resolve(res);
            }
        });
    });
};

//关闭当前webview
export const appCloseCurrentPage = () => {
    return new Promise((resolve) => {
        efbridge?.callHandler('closeCurrentpage', {}, (res: any) => {
            if (res) {
                resolve(res);
            }
        });
    });
};

// 配置当前webview参数 如是否吸顶 是否显示导航栏 导航栏颜色 导航栏字体颜色
export const appSetPageConfig = (params: PageConfigPorps) => {
    return new Promise((resolve) => {
        efbridge?.callHandler(
            'setPageConfig',
            {
                ...params,
            },
            (res: any) => {
                console.log('setPageConfig->', res);
                resolve(res);
            },
        );
    });
};

// 配置当前webview右侧按钮参数 method 是点击事件的callback名称
export const appSetRight = (params: RightConfigProps) => {
    const { method, success, ...data } = params;
    const result = method
        ? {
              method,
              ...data,
          }
        : data;
    return new Promise((resolve) => {
        efbridge?.callHandler(
            'setRight',
            {
                ...result,
            },
            (res: any) => {
                if (method && success) {
                    appRegisterH5CallbackSuccess({
                        method,
                        callback: success,
                    });
                }
                resolve(res);
            },
        );
    });
};

//配置 webview H5 callback
export const appRegisterH5CallbackSuccess = (params: RegisterSuccessProps) => {
    const { method, callback } = params;
    return new Promise((resolve) => {
        efbridge?.registerHandler(method, (res: any) => {
            console.log('registerHandler->callback->', res);
            callback && callback(res);
            resolve(res);
        });
    });
};

// 判断 网络连接状态
export const appNetworkAvailable = () => {
    return new Promise((resolve) => {
        efbridge?.registerHandler('appNetworkAvailable', (res: any) => {
            console.log('appNetworkAvailable', res);
            if (res) {
                resolve(res);
            }
        });
    });
};

export const appLogwebLoadMetrics = (data: any) => {
    return new Promise((resolve) => {
        efbridge?.callHandler('webLoadMetrics', data, (res: any) => {
            if (res) {
                resolve(res);
            }
        });
    });
};

interface appNotifyNativeMessageProps {
    type: string;
    data: object;
}

//新增H5信息通知APP
export const appNotifyNativeMessage = (data: appNotifyNativeMessageProps) => {
    return new Promise((resolve) => {
        efbridge?.callHandler('getMessage', data, (res: any) => {
            if (res) {
                resolve(res);
            }
        });
    });
};

// 获取app code_verifier
export const appGetCodeVerifier = () => {
    return new Promise((resolve) => {
        efbridge?.callHandler('getCodeVerifier', {}, (res: any) => {
            if (res) {
                resolve(res);
            }
        });
    });
};
